import React, { createRef, useEffect, useState } from "react";
import DatePicker from "react-datepicker";
// import addImage from '../assets/add_image.jpg'
import { Modal } from "bootstrap";

import "react-datepicker/dist/react-datepicker.css";
import { useEvents } from "../context/events";

const nuevoEvento = {
    name: '',
    date: new Date(),
    img: '/assets/leclab-madrid-vertical.png',
    text1: '',
    text2: '',
    description: '',
    bcolor: 'white',
    link: '',
    linkB: '',
    sButton: false,
}

export const EventModal = React.forwardRef(({ data, hideModal }, ref) => {
    const [loading, setLoading] = useState(false)
    const [eventData, setEventData] = useState(nuevoEvento)

    const { createEvent, updateEvent } = useEvents()

    const handleImageChange = (value) => {
        // var imageFile = URL.createObjectURL(e.target.files[0])
        // setEventData({ ...promo, img: imageFile })
        if (value === "Leclab Royal") {
            setEventData({ ...eventData, img: "/assets/evento_leclab_royal.jpg", type: value })
        }
        else if (value === "Lunes de Leclab") {
            setEventData({ ...eventData, img: "/assets/promo_lunes_leclab.jpg", type: value })
        }
        else if (value === "Taller") {
            setEventData({ ...eventData, img: "/assets/evento_taller.jpg", type: value })
        }
        else if (value === "Fiesta Leclab") {
            setEventData({ ...eventData, img: "/assets/evento_fiesta_leclab.jpg", type: value })
        }
        else {
            setEventData({ ...eventData, img: "/assets/leclab-madrid-vertical.png", type: value })
        }
    }

    const handleInputChange = (e) => {
        var name = e.target.name
        var value = e.target.value
        setEventData({ ...eventData, [name]: value })
    }

    const doSubmit = (e) => {
        e.preventDefault()
        setLoading(true)
        if (eventData.id) {
            updateEvent(eventData).then(() => {
                setLoading(false)
            })
        }
        else {
            createEvent(eventData).then(() => {
                setLoading(false)
            })
        }
        hideModal()
        setEventData(nuevoEvento)
    }

    useEffect(() => {
        if (!data) return
        setEventData(data)
    }, [])

    return (
        <div className="modal fade" ref={ref} tabIndex="-1">
            <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title" id="exampleModalLabel">{eventData?.name ? 'Editar evento' : 'Nuevo evento'}</h5>
                        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div className="modal-body">
                        <div className="container d-flex flex-column justify-content-around align-items-center">
                            <div className="crop">
                                <img src={eventData.img} className="img-thumbnail mb-4" alt="..." />
                            </div>
                            <div className="row text-start">
                                <div className="col-12 form-group mb-3">
                                    <label className="form-label">Tipo de evento</label>
                                    <select className="form-select" value={eventData.type} onChange={e => handleImageChange(e.target.value)}>
                                        <option value="">--</option>
                                        <option value="Leclab Royal">Leclab Royal</option>
                                        <option value="Lunes de Leclab">Lunes de Leclab</option>
                                        <option value="Taller">Taller</option>
                                        <option value="Fiesta Leclab">Fiesta Leclab</option>
                                    </select>
                                </div>
                                <div className="col-6 text-start mb-3">
                                    <label className="form-label">Nombre del evento</label>
                                    <input type="text" className="form-control" name='name' value={eventData.name} onChange={handleInputChange} />
                                </div>
                                <div className="col-6 text-start mb-3">
                                    <label className="form-label">Fecha</label>
                                    <DatePicker selected={eventData.date} onChange={(date) => handleInputChange({ target: { name: 'date', value: date } })}
                                        customInput={
                                            <div className="input-group">
                                                <input className="form-control" value={eventData.date.toLocaleDateString()} disabled />
                                                <span className="input-group-text"><i className="fa fa-calendar" /></span>
                                            </div>
                                        }
                                    />
                                </div>
                                <div className="col-12 text-start mb-3">
                                    <label className="form-label">Texto 1</label>
                                    <input type="text" className="form-control" name='text1' value={eventData.text1} onChange={handleInputChange} />
                                </div>
                                <div className="col-12 text-start mb-3">
                                    <label className="form-label">Texto 2</label>
                                    <input type="text" className="form-control" name='text2' value={eventData.text2} onChange={handleInputChange} />
                                </div>
                                <div className="col-12 form-group mb-3">
                                    <label className="form-label">Descripción</label>
                                    <textarea type="text" className="form-control" rows={5} name='description' value={eventData.description} onChange={handleInputChange} />
                                </div>
                                <div className="col-12 form-group mb-3">
                                    <label className="form-label">Link de compra</label>
                                    <input type="text" className="form-control" name='link' value={eventData.link} onChange={handleInputChange} />
                                </div>
                                <div className="col-12 form-group mb-3">
                                    <label className="form-label">Segundo Link</label>
                                    <select className="mx-2" value={eventData.sButton} onChange={e => setEventData({ ...eventData, sButton: !eventData.sButton })}>
                                        <option value={false}>No</option>
                                        <option value={true}>Sí</option>
                                    </select>
                                    <input disabled={!eventData.sButton} type="text" className="form-control" name='linkB' value={eventData.linkB} onChange={handleInputChange} />
                                </div>
                            </div>

                        </div>
                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn btn-dark" onClick={doSubmit}>{loading ? <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> : 'Guardar'}</button>
                    </div>
                </div>
            </div>
        </div>
    )
})

const EventRow = ({ data: evento }) => {

    const { deleteEvent } = useEvents()

    const modalRef = createRef()

    const showModal = () => {
        const modalEle = modalRef.current
        const bsModal = new Modal(modalEle, {
            backdrop: 'static',
            keyboard: false
        })
        bsModal.show()
    }

    const hideModal = () => {
        const modalEle = modalRef.current
        const bsModal = Modal.getInstance(modalEle)
        bsModal.hide()
        // refresh()
    }

    const getStatus = () => {
        const today = new Date()
        if (new Date(evento.date) < today) return <span className="text-danger">Out of Date</span>
        return <span className="text-success">On Going</span>
    }

    const doDelete = (e) => {
        e.preventDefault()
        if (window.confirm('¿Está seguro de que desea eliminar este evento?')) deleteEvent(evento.id)
        return
    }

    return (
        <tr>
            <td valign="middle"><img width={150} src={evento.img} /></td>
            <td valign="middle">{evento.name}</td>
            <td valign="middle">{new Date(evento.date).toLocaleDateString()}</td>
            <td valign="middle">{getStatus()}</td>
            <td valign="middle">
                <div>
                    <button className="btn btn-sm btn-outline-success me-1" onClick={showModal}>
                        <i className="fa fa-pencil" style={{ fontSize: '18px' }} />
                    </button>
                    <button className="btn btn-sm btn-outline-danger" onClick={doDelete}>
                        <i className="fa fa-trash" style={{ fontSize: '18px' }} />
                    </button>
                    <EventModal data={evento} hideModal={hideModal} ref={modalRef} />
                </div>
            </td>
        </tr>
    )
}

export default EventRow